import { render, staticRenderFns } from "./MyRacePanel.vue?vue&type=template&id=2039640c&scoped=true&"
import script from "./MyRacePanel.vue?vue&type=script&lang=js&"
export * from "./MyRacePanel.vue?vue&type=script&lang=js&"
import style0 from "./MyRacePanel.vue?vue&type=style&index=0&id=2039640c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039640c",
  null
  
)

export default component.exports